function UnauthorizedPage(){

    return <>Acceso no permitido</>

}

export default UnauthorizedPage;